import { render, staticRenderFns } from "./ApprovalDetailRow.vue?vue&type=template&id=7408b250"
import script from "./ApprovalDetailRow.vue?vue&type=script&lang=js"
export * from "./ApprovalDetailRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports